export function equalSplit(realTotal, count) {
  if (count <= 0) return []
  const base = Math.floor(realTotal / count)
  const remainder = realTotal - base * count
  const result = new Array(count).fill(base)
  result[count - 1] = base + remainder

  return result
}

export function remainingAmount(realTotal, allocated) {
  const sum = allocated.reduce((acc, n) => acc + n, 0)

  return realTotal - sum
}

export function assignRemaining(allocated, index, realTotal) {
  const next = allocated.slice()
  next[index] = (next[index] || 0) + remainingAmount(realTotal, allocated)

  return next
}

export function isValidSplit(realTotal, allocated) {
  if (allocated.length === 0) return false

  return remainingAmount(realTotal, allocated) === 0
}

// 分割行 1 件を slip-print のオプションに変換する。
// プレビューと印刷の両方で使うため、baseOptions (receiptSlipNumber 等) はそのまま流す。
export function splitRowOptions(baseOptions, row) {
  return {
    ...(baseOptions || {}),
    customerName: row.to || '',
    receiptNote: row.note || '',
    // 発行日が未選択 (空) の行は日付なしで発行する。slip-print 側は
    // date が falsy なら空欄の日付欄を描画する。
    date: row.issuedDate || undefined,
    total: Number(row.amount || 0),
    footerItems: [],
  }
}
